import * as React from 'react';
import { JSX, Key } from 'react';
import { RowDataType } from 'types/common/common';

interface Props {
    cellComponentValues: JSX.Element[];
    index: any;
    RowComponent: React.ComponentType<{
        key: Key | null | undefined;
        data: RowDataType;
        children: React.ReactNode;
        onClick?: () => void;
    }>;
    rowData: RowDataType;
    rowClickFunction?: (rowData: RowDataType) => void;
}
export const InitValueCell: React.FC<Props> = (props: Props) => {
    const {
        cellComponentValues,
        index,
        RowComponent,
        rowData,
        rowClickFunction,
    } = props;
    return (
        <RowComponent
            onClick={() => rowClickFunction?.(rowData)}
            key={index}
            data={rowData}
        >
            {cellComponentValues.map(
                (cellComponentValue) => cellComponentValue,
            )}
        </RowComponent>
    );
};
